import { push } from "connected-react-router";
import { filter, isEmpty } from "ramda";
import { useCallback, useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Row, SortingRule } from "react-table";
import { createStructuredSelector } from "reselect";
import { selectUserInfo } from "../../../App/module/selectors";
import {
  ISectionType,
  ITableType,
} from "../../../common/TablesConfiguration/tcConstants";
import FilterTable from "../../../components/FilterTable/FilterTable";
import Loader from "../../../components/Loader/Loader";
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import Table from "../../../components/Table/Table";
import {
  ITaskItem,
  REQUEST_ACTION_LIST,
  TaskActionType,
} from "../../../models/Task";
import { IBasicRole } from "../../../models/User";
import { ROUTES } from "../../../module/constants";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import Panel from "../../../ui/Panel/Panel";
import {
  convertStoredFilterToState,
  extractDateRange,
} from "../../../utils/utils";
import {
  cancelTakeChargeRequest,
  fetchPaginatedTask,
  fetchTask,
  resetTaskDetail,
  selectTaskRequest,
  takeChargeRequest,
  fetchCSVTask,
} from "../module/actions";
import { TASKS_REQUEST_FORM_FILTER, TASKS_URLS } from "../module/constants";
import {
  csvTaskList,
  csvTaskLoaded,
  selectFormTaskValues,
  selectTaskListLoader,
  selectTaskMainCallStateTakeCharge,
  taskList,
} from "../module/selector";
import { ITaskListProps } from "./module/constants";
import messages from "./module/messages";
import filterMessages from "../../../translations/filterMessages";
import classes from "./TaskManagementList.module.scss";

const tasksFilterForm = TASKS_REQUEST_FORM_FILTER;
const TAKE_CHARGE_IDENTIFIER: string = "TAKE_CHARGE";
const UNTAKE_CHARGE_IDENTIFIER: string = "UNTAKE_CHARGE";

const TaskTypeFilter = {
  idFilter: "id",
  typeFilter: "type",
  statusFilter: "status",
  applicationFilter: "application",
  entitlementFilter: "entitlement",
  beneficiaryFilter: "beneficiary",
  applicantFilter: "applicant",
  creationDateFilter: "createdOn",
  actionFilter: "action",
  inChargeOfFilter: "enrichment",
};

const TaskManagementList = (props: ITaskListProps) => {
  const {
    cancelTakeChargeRequest,
    fetchCSVTask,
    fetchPaginatedTask,
    formValuesTask,
    resetTaskDetail,
    selectTask,
    takeChargeCallState,
    takeChargeRequest,
    changeLocation,
    taskListLoader,
    userInfo,
    rawPaginationTableData,
    csvTaskLoaded,
    csvTaskList,
  } = props;

  const csvBtnRef = useRef(null);

  const [showTakeChargeConfirmModal, setShowTakeChargeConfirmModal] =
    useState(false);
  const [showTakeChargeResponseModal, setShowTakeChargeResponseModal] =
    useState(false);
  const [taskFilter, setTaskFilter] = useState<any>(
    formValuesTask && formValuesTask.values
      ? convertStoredFilterToState(formValuesTask, {
          typeFilter: TaskTypeFilter,
        })
      : ([] as any[])
  );
  const [csvDataSource, setCsvDataSource] = useState<any>([]);
  const [firstCsvDataInit, setFirstCsvDataInit] = useState<any>(true);
  const [csvDataLoaded, setCsvDataLoaded] = useState<any>(false);
  const [selectedTask, setSelectedTask] = useState([]);

  const [paginationTableData, setPaginationTableData] = useState([] as any[]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageTotalNumber, setPageTotalNumber] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [sortBy, setSortBy] = useState<SortingRule<{}>[]>([]);

  useEffect(() => {
    if (!paginationTableData || paginationTableData.length === 0) {
      getPaginationTableData(0, pageSize ? pageSize : 50, taskFilter);
    }
  }, [taskFilter]);

  useEffect(() => {
    setPageNumber(rawPaginationTableData.pageNumber);
    setPageTotalNumber(rawPaginationTableData.pageTotalNumber);
    setTotalElements(rawPaginationTableData.totalElements);
    if (rawPaginationTableData?.tasks)
      setPaginationTableData(rawPaginationTableData.tasks);
  }, [rawPaginationTableData]);

  const filterBody = useCallback((filter) => {
    const { startDate, endDate } = extractDateRange(filter, "createdOn");

    let body = {
      id: filter?.filter((filterElement: any) => filterElement.id === "id")[0]
        ?.value,

      action: filter?.filter(
        (filterElement: any) => filterElement.id === "action"
      )[0]?.value,

      applicantFullname: filter?.filter(
        (filterElement: any) => filterElement.id === "applicant"
      )[0]?.value,

      entitlement: filter?.filter(
        (filterElement: any) => filterElement.id === "entitlement"
      )[0]?.value,

      inChargeOf: filter?.filter(
        (filterElement: any) => filterElement.id === "enrichment"
      )[0]?.value,

      beneficiary: filter?.filter(
        (filterElement: any) => filterElement.id === "beneficiary"
      )[0]?.value,

      application: filter?.filter(
        (filterElement: any) => filterElement.id === "application"
      )[0]?.value,

      createdOnStart: startDate,
      createdOnEnd: endDate,

      // createdOnStart: filter?.filter(
      //   (filterElement: any) => filterElement.id === "createdOn"
      // )[0]?.value[0],
      // createdOnEnd: filter?.filter(
      //   (filterElement: any) => filterElement.id === "createdOn"
      // )[0]?.value[1],
    };
    return body;
  }, []);

  const getPaginationTableData = useCallback(
    (
      pageNumber: number,
      pageSize: number,
      filter: any[],
      sortBy: SortingRule<{}>[] = []
    ) => {
      setPageSize(pageSize);
      setPageIndex(pageNumber);
      setSortBy(sortBy);

      let body = {
        pageNumber: pageNumber + 1,
        pageSize: pageSize,

        ...filterBody(filter),
      };
      if (sortBy.length === 0) {
        let sortBy = [
          {
            id: "createdOn",
            desc: true,
          },
        ];
        fetchPaginatedTask({ body, sortBy });
      } else {
        fetchPaginatedTask({ body, sortBy });
      }
      const { pageNumber: _pageNum, pageSize: _pageSize, ...rest } = body;
    },
    []
  );

  const onCSVClick = useCallback(() => {
    console.log("onCSVClick");
    setFirstCsvDataInit(false);
    setCsvDataLoaded(false);
    let body = filterBody(taskFilter);

    fetchCSVTask(body);
  }, [taskFilter, fetchCSVTask, filterBody]);

  useEffect(() => {
    if (csvTaskLoaded && csvTaskList && csvTaskList.length > 0) {
      setCsvDataSource(csvTaskList);
    }
  }, [csvTaskLoaded, csvTaskList]);

  useEffect(() => {
    if (csvDataSource && csvDataSource.length > 0) {
      setCsvDataLoaded(true);
      setFirstCsvDataInit(false);
      (csvBtnRef.current as any)?.link.click();
    }
  }, [csvDataSource]);

  useEffect(() => {
    resetTaskDetail();
  }, []);

  const checkboxTaskHandler = (checkedElements: Row<object>[]) => {
    const checkedRequests: any = checkedElements.map((req) => req.original);
    setSelectedTask(checkedRequests);
  };

  const onTaskFilterSubmit = (values: any) => {
    if (values) {
      const { advancedSearchFilter, ...rest } = values;
      let valueFilter: any[] = [];
      if (rest && isEmpty(rest)) return setTaskFilter([]);
      Object.keys(rest).forEach((element: any) => {
        valueFilter.push({
          id: TaskTypeFilter[element as keyof typeof TaskTypeFilter],
          value: rest[element],
          operation: "AND",
        });
      });
      setTaskFilter(valueFilter);
    }
  };

  const showConfirmModalTakeChargeHandler = () => {
    setShowTakeChargeConfirmModal(true);
  };

  const onAcceptTakeChargeConfirmModal = () => {
    const tempAcceptReqList: any[] = [];
    selectedTask.forEach((task: any) => {
      tempAcceptReqList.push(task.id);
    });
    const isTakeChargeRes = isTakeCharge();
    if (isTakeChargeRes === TAKE_CHARGE_IDENTIFIER) {
      const tempRequest = filter((el: any) => {
        if (el.hidden_enrichment_id === userInfo.code) return false;
        return true;
      }, tempAcceptReqList);
      takeChargeRequest(tempRequest);
    }
    if (isTakeChargeRes === UNTAKE_CHARGE_IDENTIFIER)
      cancelTakeChargeRequest(tempAcceptReqList);

    setShowTakeChargeConfirmModal(false);
    setShowTakeChargeResponseModal(true);
  };

  const onCancelTakeChargeConfirmModal = () => {
    setShowTakeChargeConfirmModal(false);
  };

  const onCloseTakeChargeResponseModal = () => {
    setShowTakeChargeResponseModal(false);
    getPaginationTableData(
      pageNumber - 1,
      pageSize ? pageSize : 10,
      taskFilter
    );
  };

  const isTakeCharge = (): "TAKE_CHARGE" | "UNTAKE_CHARGE" | "" | string => {
    if (selectedTask.length === 0) return "";

    const unTakeChargelength = filter((el: any) => {
      if (el.enrichmentCode && el.enrichmentCode === userInfo.code) return true;

      return false;
    }, selectedTask).length;

    if (unTakeChargelength === selectedTask.length)
      return UNTAKE_CHARGE_IDENTIFIER;

    return TAKE_CHARGE_IDENTIFIER;
  };

  return (
    <>
      <ResponseModal
        show={showTakeChargeResponseModal}
        state={takeChargeCallState}
        onClose={() => onCloseTakeChargeResponseModal()}
      />
      <ConfirmModal
        show={showTakeChargeConfirmModal}
        onCancel={onCancelTakeChargeConfirmModal}
        onConfirm={onAcceptTakeChargeConfirmModal}
        extraMessage={
          isTakeCharge() === TAKE_CHARGE_IDENTIFIER &&
          filter(
            (el: any) =>
              el.enrichmentCode && el.enrichmentCode !== userInfo.code
                ? true
                : false,
            selectedTask
          ).length > 0 ? (
            <FormattedMessage {...messages.alreadyCharge} />
          ) : null
        }
      />
      <div>
        <div className={classes.topActions}>
          <OutlinedButton onClick={() => changeLocation(ROUTES.WELCOME)}>
            <FormattedMessage {...messages.CTAExit} />
          </OutlinedButton>
        </div>
      </div>
      <Panel title={"TASKS"}>
        <div className={classes["tab-wrapper"]}>
          <FilterTable
            messages={filterMessages}
            listsFilter={{
              TASK_REQUEST_ACTION_LIST: {
                list: REQUEST_ACTION_LIST,
                type: TaskActionType,
              },
            }}
            formProps={tasksFilterForm}
            onSubmitProps={onTaskFilterSubmit}
            isAccordion={true}
            sectionType={ISectionType.TASKS}
            tableType={ITableType.TASKS_REQUESTS_TABLE}
            typeFilter={TaskTypeFilter}
          />
          {userInfo &&
          userInfo.roles.basicRoles.find(
            (role: IBasicRole) => role.roleName === "Security Operation"
          ) ? (
            <div className={classes["actions-charge"]}>
              {selectedTask.length > 0 ? (
                <OutlinedButton
                  onClick={() => showConfirmModalTakeChargeHandler()}
                >
                  {isTakeCharge() === TAKE_CHARGE_IDENTIFIER ? (
                    <FormattedMessage {...messages.takeCharge} />
                  ) : (
                    <FormattedMessage {...messages.untakeCharge} />
                  )}
                </OutlinedButton>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <>
              {selectedTask.length > 0 && (
                <div>
                  <b>
                    <FormattedMessage {...messages.cantTakeChargeMsg} />
                  </b>
                </div>
              )}
            </>
          )}
          {taskListLoader && (
            <div className={classes.loaderErrorWrapper}>
              <Loader />
            </div>
          )}
          {!taskListLoader &&
            paginationTableData &&
            paginationTableData.length > 0 && (
              <Table
                filterProps={taskFilter}
                rowsChangeable
                showDetail
                dataSource={paginationTableData}
                detailURL={TASKS_URLS.TASK_REQUEST_DETAIL}
                onDetailClick={selectTask}
                showChekbox
                selectAll
                onCheckboxChangeEvent
                onCheckboxChange={checkboxTaskHandler}
                tableName={"Tasks_list"}
                CSVRef={csvBtnRef}
                CSVData={csvDataSource}
                CSVDisabled={!firstCsvDataInit && !csvDataLoaded}
                onClickCSV={onCSVClick}
                sectionType={ISectionType.TASKS}
                tableType={ITableType.TASKS_REQUESTS_TABLE}
                serverSidePagination
                serverSideSorting
                fetchData={getPaginationTableData}
                pageCount={pageTotalNumber}
                pageIndexProp={pageIndex}
                totalElements={totalElements}
                pageSizeProp={pageSize}
                sortByProp={sortBy}
              />
            )}

          {paginationTableData && paginationTableData?.length === 0 && (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center">
              {" "}
              <FormattedMessage {...messages.emptyTable} />{" "}
            </div>
          )}
          {!paginationTableData && (
            <div className={classes.loaderErrorWrapper}>
              {}
              {paginationTableData === undefined && (
                <span>
                  <FormattedMessage {...messages.unauthTaskViewer} />
                </span>
              )}
            </div>
          )}
        </div>
      </Panel>
      <div className={classes.bottomActions}>
        <OutlinedButton onClick={() => changeLocation(ROUTES.WELCOME)}>
          <FormattedMessage {...messages.CTAExit} />
        </OutlinedButton>
      </div>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    taskListLoader: selectTaskListLoader,
    formValuesTask: selectFormTaskValues,
    userInfo: selectUserInfo,
    takeChargeCallState: selectTaskMainCallStateTakeCharge,
    rawPaginationTableData: taskList,
    csvTaskLoaded,
    csvTaskList,
  });

const mapDispatchToProps: any = {
  changeLocation: (url: string) => push(url),
  selectTask: (row: ITaskItem) => selectTaskRequest(row),
  fetchTask: () => fetchTask(),
  fetchPaginatedTask,
  takeChargeRequest,
  cancelTakeChargeRequest,
  resetTaskDetail,
  fetchCSVTask,
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(TaskManagementList);
